/* global Phaser */

import * as setup from '@/setup';

export default class Cursor {
	constructor(boardBoxes) {
		// dichiaro le variabili pubbliche
		this.index = 0;
		this.indexAfterPower = 0;
		this.indexBeforePower = 0;

		// dichiaro le variabili private
		this._boardBoxes = boardBoxes;
		this._animation = [];

		// Aggiungo un animazione a ogni casella dello schema interattiva
		let i = 0;
		let firstTime = false;
		Phaser.Actions.Call(
			boardBoxes.getChildren(),
			function (cell) {
				if (cell.input && cell.input.enabled) {
					// posizione iniziale del cursore
					if (firstTime === false) {
						this.index = i;
						firstTime = true;
					}
					// animazione solo sulle caselle interattive
					if (this._animation[i]) {
						this._animation[i].stop();
						//this._tw1.destroy();
					}

					// Valori from/to espliciti così durante il lampeggio la casella non scompare
					this._animation[i] = cell.scene.tweens.add({
						targets: cell,
						scaleX: { from: setup.box.scale, to: setup.box.scale - 0.05 },
						scaleY: { from: setup.box.scale, to: setup.box.scale - 0.05 },
						alpha: { from: 1, to: 0.5 },
						ease: 'Sine.easeInOut',
						duration: 300,
						delay: 0,
						repeat: -1,
						yoyo: true,
						paused: true
					});

				}
				i++;
			},
			this
			);
	}

	move(newIndex) {
		console.log('[Cursor] move: da indice', this.index, 'a indice', newIndex, '(differenza: ' + (newIndex - this.index) + ')');
		// metti in pausa animazione del vecchio box
		if (this._animation[this.index] && this._animation[this.index].isPlaying)
			this._animation[this.index].pause();

		// Resetta il vecchio box (tint, alpha e scale così la casella non "scompare")
		var oldCell = this._boardBoxes.getChildren()[this.index];
		console.log('[Cursor] move: vecchia casella char=', JSON.stringify(oldCell.datas.char), 'solution=', oldCell.datas.solution);
		oldCell.setTint();
		oldCell.setAlpha(1);
		oldCell.setScale(setup.box.scale);

		// Ripristina lo stato iniziale del nuovo box prima di avviare l'animazione
		var newCell = this._boardBoxes.getChildren()[newIndex];
		console.log('[Cursor] move: nuova casella char=', JSON.stringify(newCell.datas.char), 'solution=', newCell.datas.solution);
		newCell.setScale(setup.box.scale);
		newCell.setAlpha(1);
		newCell.setTint(setup.colors.boardBlink);

		// Faccio ripartire l'animazione del nuovo box
		this._animation[newIndex].seek(0);
		this._animation[newIndex].resume();

		// Riposiziono il cursore
		this.index = newIndex;
	}

	pauseCurrent() {
		var cell = this._boardBoxes.getChildren()[this.index];
		cell.setTint();
		cell.setAlpha(1);
		cell.setScale(setup.box.scale);
		this._animation[this.index].pause();
	}

	searchFreeBox(cursorIndex) {
		console.log('[Cursor] searchFreeBox: partendo da indice', cursorIndex);
		for (let index = cursorIndex; index < this._boardBoxes.getChildren().length; ++index) {
			let cell = this._boardBoxes.getChildren()[index];
			console.log('[Cursor] searchFreeBox: controllo indice', index, 'char=', JSON.stringify(cell.datas.char), 'solution=', cell.datas.solution, 'interattiva=', cell.input && cell.input.enabled);
			if (cell.datas.char !== false && cell.datas.char === ' ') {
				console.log('[Cursor] searchFreeBox: trovata casella vuota a indice', index);
				return index;
			}
		}
		console.log('[Cursor] searchFreeBox: nessuna casella vuota trovata');
		return false;
	}

	findNextCursor(lastLetterIndex, currentIndex) {
		console.log('[Cursor] findNextCursor: lastLetterIndex=', lastLetterIndex, 'currentIndex=', currentIndex);
		// di default va alla casella successiva
		let nextIndex = currentIndex + 1;
		console.log('[Cursor] findNextCursor: nextIndex iniziale (currentIndex+1)=', nextIndex);

		// se siamo OLTRE l'ultima casella riparti da zero
		// (lastLetterIndex è l'ultimo indice valido, quindi ripartiamo solo se nextIndex lo supera)
		if (nextIndex > lastLetterIndex) {
			nextIndex = 0;
			console.log('[Cursor] findNextCursor: siamo oltre l\'ultima casella, ripartendo da 0');
		}

		// cerca il cursore a partire da quello corrente
		nextIndex = this.searchFreeBox(nextIndex);
		console.log('[Cursor] findNextCursor: searchFreeBox ha restituito', nextIndex);
		if (!nextIndex && nextIndex !== 0) {
			// se  non trovo niente cerco dall'inizio
			console.log('[Cursor] findNextCursor: non trovato, cerco dall\'inizio');
			nextIndex = this.searchFreeBox(0);
		}

		// se non trovo nniente neanche adall'inizio allora ho finito
		if (!nextIndex && nextIndex !== 0) {
			// finito le lettere, partita finita. Fermo il cursore
			console.log('[Cursor] findNextCursor: nessuna casella libera, partita finita');
			this.pauseCurrent();
			return false;
		}

		let resultBox = this._boardBoxes.getChildren()[nextIndex];
		console.log('[Cursor] findNextCursor: nuovo cursore a indice', nextIndex, 'box.datas=', resultBox.datas);
		return resultBox;
	}
}
